import React, { useState, useEffect } from "react";
import axiosInstance from '../../api/axios';

const dates = [
  { value: "2026-08-03", label: "08/03/26" },
  { value: "2026-08-04", label: "08/04/26" },
  { value: "2026-08-05", label: "08/05/26" },
  { value: "2026-08-06", label: "08/06/26" },
  { value: "2026-08-07", label: "08/07/26" },
  { value: "2026-08-10", label: "08/10/26" },
  { value: "2026-08-11", label: "08/11/26" },
  { value: "2026-08-12", label: "08/12/26" },
  { value: "2026-08-13", label: "08/13/26" },
  { value: "2026-08-14", label: "08/14/26" }
];

const slotOptionsMorning = [
  { value: "", label: "N/A" }, 
  { value: "09:00:00", label: "9:00 AM" },
  { value: "09:30:00", label: "9:30 AM" },
  { value: "10:00:00", label: "10:00 AM" }
];

const slotOptionsAfternoon = [
  { value: "", label: "N/A" },
  { value: "14:30:00", label: "2:30 PM" },
  { value: "15:00:00", label: "3:00 PM" }
];

const slotOptionsEvening = [
  { value: "", label: "N/A" },
  { value: "17:00:00", label: "5:00 PM" },
  { value: "17:30:00", label: "5:30 PM" }
];

const countOptions = ["0", "4", "5", "6"];

export const VivaSlot = () => {
  const examinerId = parseInt(localStorage.getItem('examinerId'), 10);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [preferredSlotCount, setPreferredSlotCount] = useState("");
  const [comments, setComments] = useState("");

  const fetchExistingSlots = async () => {
    try {
      const response = await axiosInstance.get("/getSlots", {
        params: { examinerId: examinerId }
      });
      
      const apiData = response.data.data;
      const loadedRows = apiData.rows.map(row => ({
          id: row.id,
          date: row.date,
          displayDate: row.displayDate || '', 
          morningSlot: row.morningSlot || "",
          morningCount: row.morningCount || "",
          morningDisabled: row.morningDisabled === true, 
          afternoonSlot: row.afternoonSlot || "",
          afternoonCount: row.afternoonCount || "",
          afternoonDisabled: row.afternoonDisabled === true,
          eveningSlot: row.eveningSlot || "",
          eveningCount: row.eveningCount || "",
          eveningDisabled: row.eveningDisabled === true
        }));
      
      setRows(loadedRows);
      setPreferredSlotCount(apiData.preferredSlotCount != null ? String(apiData.preferredSlotCount) : "");
      setComments(apiData.comments || "");
      setLoading(false);
    } catch (error) {
      console.error("Error loading slots:", error);
      setLoading(false);
      setRows(
          dates.map((date) => ({
              date: date.value,
              displayDate: date.label,
              morningSlot: "",
              morningCount: "0",
              morningDisabled: true,
              afternoonSlot: "",
              afternoonCount: "0",
              afternoonDisabled: true,
              eveningSlot: "",
              eveningCount: "0",
              eveningDisabled: true
          }))
        );
    }
  };

  useEffect(() => {
    fetchExistingSlots();
  }, [examinerId]);

  const handleChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    
    if (field === "morningSlot") {
      updatedRows[index].morningDisabled = value === "";
      if (value === "") updatedRows[index].morningCount = "";
    } else if (field === "afternoonSlot") {
      updatedRows[index].afternoonDisabled = value === "";
      if (value === "") updatedRows[index].afternoonCount = "";
    } else if (field === "eveningSlot") {
      updatedRows[index].eveningDisabled = value === "";
      if (value === "") updatedRows[index].eveningCount = "";
    }
    
    setRows(updatedRows);
  };

  const handleSubmit = async () => {
    if (!preferredSlotCount) {
      alert("Please select how many slots you prefer to be assigned before saving.");
      return;
    }
    try {
      const payload = {
        rows: rows.map(row => ({
          ...row,
          examinerId: examinerId
        })),
        preferredSlotCount: preferredSlotCount !== "" ? parseInt(preferredSlotCount, 10) : null,
        comments: comments || null,
      };
      
      await axiosInstance.post("/slotSelection", payload);
      alert("Saved successfully");
      fetchExistingSlots();
    } catch (error) {
      alert("Error saving data");
    }
  };

  if (loading) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        Loading slots...
      </div>
    );
  }

  return (
    <div style={{ padding: "20px" }}>
      <h1>Viva Slot Preferences</h1>

      <div style={{
        marginBottom: "18px",
        display: "flex",
        flexDirection: "column",
        gap: 10
      }}>
        <div style={{
          padding: "12px 16px",
          background: "#e3f2fd",
          border: "1px solid #90caf9",
          borderRadius: 6,
          fontSize: 14,
          color: "#0d3b66",
          lineHeight: "1.6"
        }}>
          <strong>Instructions:</strong>
          <ul style={{ margin: "6px 0 0 18px", padding: 0 }}>
            <li>Please fill in <strong>all dates and time slots where you are available</strong>.</li>
            <li>Each viva requires <strong>30 minutes</strong> per student. Enter the maximum number of students you can accommodate in each slot.</li>
            <li>Providing more availability helps with scheduling — <strong>only 1 or more </strong> of your submitted slots based on your preference will be finally assigned for the viva.</li>
          </ul>
        </div>

        <div style={{
          padding: "10px 16px",
          background: "#fff3e0",
          border: "1px solid #ffb74d",
          borderRadius: 6,
          fontSize: 13,
          color: "#7c4a00"
        }}>
          &#9432;&nbsp; Select <strong>N/A</strong> for any time of day you are <em>not</em> available. The student count field will be automatically disabled.
        </div>
      </div>

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={thStyle}>Date</th>
            <th style={thStyle}>Slot (morning)</th>
            <th style={thStyle}>Number of students for morning slot</th>
            <th style={thStyle}>Slot (afternoon)</th>
            <th style={thStyle}>Number of students for afternoon slot</th>
            <th style={thStyle}>Slot (evening)</th>
            <th style={thStyle}>Number of students for evening slot</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              <td style={tdStyle}>{row.displayDate}</td>
              <td style={tdStyle}>
                <select
                  value={row.morningSlot}
                  onChange={(e) => handleChange(index, "morningSlot", e.target.value)}
                >
                  {slotOptionsMorning.map((slot) => (
                    <option key={slot.value} value={slot.value}>
                      {slot.label}
                    </option>
                  ))}
                </select>
              </td>
              <td style={tdStyle}>
                <select
                  value={row.morningCount}
                  onChange={(e) => handleChange(index, "morningCount", e.target.value)}
                  disabled={row.morningDisabled}
                  style={{ 
                    backgroundColor: row.morningDisabled ? "#f0f0f0" : "white",
                    cursor: row.morningDisabled ? "not-allowed" : "pointer"
                  }}
                >
                  {countOptions.map((count) => (
                    <option key={count} value={count}>{count}</option>
                  ))}
                </select>
              </td>

              <td style={tdStyle}>
                <select
                  value={row.afternoonSlot}
                  onChange={(e) => handleChange(index, "afternoonSlot", e.target.value)}
                >
                  {slotOptionsAfternoon.map((slot) => (
                    <option key={slot.value} value={slot.value}>
                      {slot.label}
                    </option>
                  ))}
                </select>
              </td>
              <td style={tdStyle}>
                <select
                  value={row.afternoonCount}
                  onChange={(e) => handleChange(index, "afternoonCount", e.target.value)}
                  disabled={row.afternoonDisabled}
                  style={{ 
                    backgroundColor: row.afternoonDisabled ? "#f0f0f0" : "white",
                    cursor: row.afternoonDisabled ? "not-allowed" : "pointer"
                  }}
                >
                  {countOptions.map((count) => (
                    <option key={count} value={count}>{count}</option>
                  ))}
                </select>
              </td>

              <td style={tdStyle}>
                <select
                  value={row.eveningSlot}
                  onChange={(e) => handleChange(index, "eveningSlot", e.target.value)}
                >
                  {slotOptionsEvening.map((slot) => (
                    <option key={slot.value} value={slot.value}>
                      {slot.label}
                    </option>
                  ))}
                </select>
              </td>
              <td style={tdStyle}>
                <select
                  value={row.eveningCount}
                  onChange={(e) => handleChange(index, "eveningCount", e.target.value)}
                  disabled={row.eveningDisabled}
                  style={{ 
                    backgroundColor: row.eveningDisabled ? "#f0f0f0" : "white",
                    cursor: row.eveningDisabled ? "not-allowed" : "pointer"
                  }}
                >
                  {countOptions.map((count) => (
                    <option key={count} value={count}>{count}</option>
                  ))}
                </select>
              </td>
              
            </tr>
          ))}
        </tbody>
      </table>

      <div style={{ marginTop: "28px", display: "flex", flexDirection: "column", gap: 16, maxWidth: 600 }}>
        <div>
          <label style={{ display: "block", fontWeight: 600, marginBottom: 6, fontSize: 14 }}>
            How many slots do you prefer to be assigned? <span style={{ color: "#c62828" }}>*</span>
          </label>
          <p style={{ margin: "0 0 8px", fontSize: 12, color: "#555" }}>
            Note: only <strong>1 or more slots</strong> will be finally fixed. This is your preference — the final assignment may differ based on scheduling.
          </p>
          <select
            value={preferredSlotCount}
            onChange={(e) => setPreferredSlotCount(e.target.value)}
            style={{ padding: "8px 12px", borderRadius: 4, border: preferredSlotCount ? "1px solid #ccc" : "2px solid #d32f2f", fontSize: 14, minWidth: 160 }}
          >
            <option value="">-- Select --</option>
            <option value="1">1 slot</option>
            <option value="2">2 slots</option>
            <option value="3">3 slots</option>
            <option value="4">4 slots</option>
            <option value="5">5 slots</option>
          </select>
        </div>

        <div>
          <label style={{ display: "block", fontWeight: 600, marginBottom: 6, fontSize: 14 }}>
            Any comments or constraints? <span style={{ color: "#777", fontWeight: 400 }}>(optional)</span>
          </label>
          <p style={{ margin: "0 0 8px", fontSize: 12, color: "#555" }}>
            e.g. specific dates to avoid, back-to-back slot preferences, travel constraints, etc.
          </p>
          <textarea
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            rows={3}
            maxLength={1000}
            placeholder="Enter any comments or constraints here..."
            style={{ width: "100%", padding: "8px", borderRadius: 4, border: "1px solid #ccc", fontSize: 14, resize: "vertical", boxSizing: "border-box" }}
          />
          <div style={{ fontSize: 11, color: "#888", textAlign: "right" }}>{comments.length}/1000</div>
        </div>
      </div>

      <div style={{
        marginTop: "20px",
        padding: "12px 16px",
        background: "#fff8e1",
        border: "1px solid #f9a825",
        borderRadius: 6,
        display: "flex",
        alignItems: "center",
        gap: 10,
        fontSize: 14,
        color: "#5f4100"
      }}>
        <span style={{ fontSize: 18 }}>&#9888;</span>
        After filling in your slot preferences above, click <strong>Save Response</strong> below to submit. Your selections are <strong>not saved</strong> until you click the button.
      </div>

      <button onClick={handleSubmit} style={{
        marginTop: "12px",
        padding: "10px 28px",
        background: "#1976d2",
        color: "#fff",
        border: "none",
        borderRadius: 6,
        fontSize: 15,
        fontWeight: 600,
        cursor: "pointer",
        boxShadow: "0 2px 6px rgba(25,118,210,0.35)"
      }}>
        &#128190; Save Response
      </button>
    </div>
  );
};


const thStyle = {
  border: "1px solid #ccc",
  padding: "10px",
  background: "#f5f5f5",
  textAlign: "left"
};

const tdStyle = {
  border: "1px solid #ccc",
  padding: "10px"
};
